/*
 *
 * ----------------------------------------------- */

$(window).on("load", function () {
  var $loader = $("#loader");
  if ($loader) {
    $loader.addClass("show");
    setTimeout(() => {
      $loader.fadeOut("slow");
    }, 1000);
  }
});
